import * as ambassadorWixBookingsV2BookingsSettings from './bookings-v2-bookings-settings-bookings-settings.http.js';
import * as ambassadorWixBookingsV2BookingsSettingsTypes from './bookings-v2-bookings-settings-bookings-settings.types.js';
import * as ambassadorWixBookingsV2BookingsSettingsUniversalTypes from './bookings-v2-bookings-settings-bookings-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getBookingsSettings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBookingsV2BookingsSettingsUniversalTypes.GetBookingsSettingsRequest,
  ambassadorWixBookingsV2BookingsSettingsTypes.GetBookingsSettingsRequest,
  ambassadorWixBookingsV2BookingsSettingsUniversalTypes.GetBookingsSettingsResponse,
  ambassadorWixBookingsV2BookingsSettingsTypes.GetBookingsSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2BookingsSettings.getBookingsSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateBookingsSettings(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixBookingsV2BookingsSettingsUniversalTypes.UpdateBookingsSettingsRequest,
  ambassadorWixBookingsV2BookingsSettingsTypes.UpdateBookingsSettingsRequest,
  ambassadorWixBookingsV2BookingsSettingsUniversalTypes.UpdateBookingsSettingsResponse,
  ambassadorWixBookingsV2BookingsSettingsTypes.UpdateBookingsSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2BookingsSettings.updateBookingsSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/bookings-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  BookingsSettings as BookingsSettingsOriginal,
  CartCheckout as CartCheckoutOriginal,
  MultiServiceAppointments as MultiServiceAppointmentsOriginal,
  DisplayTimeZone as DisplayTimeZoneOriginal,
  BasedOn as BasedOnOriginal,
  BasedOnWithLiterals as BasedOnWithLiteralsOriginal,
  SiteProperties as SitePropertiesOriginal,
  Locale as LocaleOriginal,
  Address as AddressOriginal,
  AddressHint as AddressHintOriginal,
  PlacementType as PlacementTypeOriginal,
  PlacementTypeWithLiterals as PlacementTypeWithLiteralsOriginal,
  GeoCoordinates as GeoCoordinatesOriginal,
  Features as FeaturesOriginal,
  Feature as FeatureOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Notifications as NotificationsOriginal,
  StaffSelection as StaffSelectionOriginal,
  StaffSelectionTiming as StaffSelectionTimingOriginal,
  StaffSelectionTimingWithLiterals as StaffSelectionTimingWithLiteralsOriginal,
  Strategy as StrategyOriginal,
  StrategyWithLiterals as StrategyWithLiteralsOriginal,
  LocationSelection as LocationSelectionOriginal,
  Timing as TimingOriginal,
  TimingWithLiterals as TimingWithLiteralsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  OwnerFlow as OwnerFlowOriginal,
  BookingCreationSettings as BookingCreationSettingsOriginal,
  RequiredField as RequiredFieldOriginal,
  RequiredFieldWithLiterals as RequiredFieldWithLiteralsOriginal,
  GetBookingsSettingsRequest as GetBookingsSettingsRequestOriginal,
  RequestedFields as RequestedFieldsOriginal,
  RequestedFieldsWithLiterals as RequestedFieldsWithLiteralsOriginal,
  GetBookingsSettingsResponse as GetBookingsSettingsResponseOriginal,
  UpdateBookingsSettingsRequest as UpdateBookingsSettingsRequestOriginal,
  UpdateBookingsSettingsResponse as UpdateBookingsSettingsResponseOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  Empty as EmptyOriginal,
  BusinessNotification as BusinessNotificationOriginal,
  Reason as ReasonOriginal,
  ReasonWithLiterals as ReasonWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  GetBookingsSettingsApplicationErrors as GetBookingsSettingsApplicationErrorsOriginal,
} from './bookings-v2-bookings-settings-bookings-settings.types.js';
